/**
 * Vida's theme, as a mountable provider — an export target (`./theme`).
 *
 * Publishable because it reaches no `@/` specifier and no `devDependency`. The
 * `@react-navigation/native` wrapper that used to live here is now
 * `app/_layout.tsx`'s local `AppThemeProvider`, on the app side of the boundary; see
 * `OnboardingThemeProvider` for why that split is what makes this module exportable.
 */
export { OnboardingThemeProvider } from './contexts/OnboardingThemeProvider';
export { onboardingTheme } from './onboardingTheme';
